import { render, staticRenderFns } from "./modalTemplate.vue?vue&type=template&id=2401bd4e&scoped=true"
import script from "./modalTemplate.vue?vue&type=script&lang=js"
export * from "./modalTemplate.vue?vue&type=script&lang=js"
import style0 from "./modalTemplate.vue?vue&type=style&index=0&id=2401bd4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2401bd4e",
  null
  
)

export default component.exports